import type { JSX } from 'react';

import { RealTimeContainer } from './RealTime.container';
import { RealTimeFetcherContainer } from './RealTimeFetcher.container';

export const RealTimeWrapper = (): JSX.Element => (
    <div className={'RealTimeContainer'}>
        <RealTimeFetcherContainer />
        <RealTimeContainer />
    </div>
);
